/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsLabourVarianceRoleCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.labour')
.controller('ReportsLabourVarianceRoleCtrl', ["$scope", "$filter", "title", "$q", "reporttime", "LabourFactory", "userinfo", function($scope, $filter, title, $q, reporttime, LabourFactory, userinfo) {
  title.set('Roles');

  $scope.chartOptions = {
    seriesType: 'bars',
    vAxis: {
      minValue: 0
    },
    hAxis: {
      ticks: [],
      gridlines: {
        color: 'transparent'
      }
    },
    legend: {position: 'none'}
  };

  $scope.graphCols = [
    {label: 'Role', type: 'string', key: 'label'},
    {label: 'Rostered', type: 'number', key: 'rosteredCost', filter: 'currency'},
    {label: 'Actual', type: 'number', key: 'actualCost', filter: 'currency'}
  ];

  function processData(roleData) {
    var hasPayrollSalaryPermissions = userinfo.companyHasPermission('Payroll,Salary');
    // We need to assume the number of cost centres can change, so we need to make our result structure flexible
    var roleResults = [];

    roleData.forEach(function(role) {

      // Discard any roles that don't have either rostered or actual costs for the period
      if ((role.rosteredCost + role.actualCost) == 0) {
        return;
      }

      roleResults.push({
        label: role.roleName,
        actualCost: hasPayrollSalaryPermissions ? role.actualCost : 0,
        rosteredCost: hasPayrollSalaryPermissions ? role.rosteredCost : 0,
        costVariance: hasPayrollSalaryPermissions ? role.actualCost - role.rosteredCost : 0,
        actualHours: role.actualHours,
        rosteredHours: role.rosteredHours,
        hoursVariance: role.actualHours - role.rosteredHours
      });

    });

    // Order by the most expensive role first
    roleResults.sort(function compare(a, b) {
      return a.actualCost < b.actualCost ? 1 :
        a.actualCost == b.actualCost ? 0 : -1;
    });

    return roleResults;
  }

  $scope.loading = $q.all({
    roleData: LabourFactory.LabourRoleAnalysis(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(results) {

    $scope.reportTableData = processData(results.roleData);

    var axisTicks = [];
    $scope.reportTableData.forEach(function(role) {

      axisTicks.push({
        v: role.roleId,
        f: role.roleName
      });

    });

    $scope.chartOptions.hAxis.ticks = axisTicks;

  });

}]);
